export const meta = {
  title: 'Privacy Policy | Firefly Wedding',
  description:
    'How the Firefly Wedding fan site handles visitor data, cookies, analytics and optional accounts.',
  updated_at: '2026-10-14',
};

## About this policy

Firefly Wedding (fireflywedding.org) is an unofficial fan site that gathers public information about the manga and anime _Hotaru no Yomeiri_ (Firefly Wedding) and links to official sources. This policy explains what information we process when you visit. Questions: [support@fireflywedding.org](mailto:support@fireflywedding.org).

## What we collect

- **Basic request data.** Like any website, our hosting provider processes your IP address, browser type and the pages you request in order to serve the site and protect it from abuse.
- **Preferences.** We store your language and light/dark theme choice in a cookie or your browser's local storage so the site remembers them.
- **Analytics.** We may use privacy-friendly analytics (for example Google Analytics, Plausible or Microsoft Clarity) to understand which pages are useful. These tools receive aggregated usage data and may set their own cookies.
- **Optional accounts.** If you create an account, we store your email address, display name and sign-in details. You can browse every public page without an account.

## External links

Watch and read links take you to third-party services such as Crunchyroll, broadcasters, streaming platforms and publishers. Their own privacy policies apply once you leave this site.

## Sharing and retention

We do not sell personal data. We share it only with the service providers needed to run the site (hosting, analytics, email) or when required by law. Account data is kept until you ask us to delete it.

## Your choices

You can block or clear cookies in your browser, and you can ask us to access or delete any account data by emailing [support@fireflywedding.org](mailto:support@fireflywedding.org).

## Changes

We may update this policy as the site grows. The date at the top shows the latest version.
